import { render, staticRenderFns } from "./drtv.vue?vue&type=template&id=bfd09be0&"
import script from "./drtv.vue?vue&type=script&lang=js&"
export * from "./drtv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports